export default [
  'M7.724 33.796L33.791 7.729a.609.609 0 0 0-.86-.861L6.864 32.935a.609.609 0 0 0 .86.861z',
  'M33.791 32.935L7.724 6.868a.609.609 0 0 0-.86.86L32.93 33.797a.609.609 0 0 0 .86-.86z',
];
